import React, { useCallback, useEffect, useState } from 'react'

import { TDateArg, dayjs } from '@hozana/dates'
import { useInterval } from '@hozana/hooks/useInterval'

export type TRelativeTimeProps = {
  date: TDateArg
  minDate?: TDateArg
  maxDate?: TDateArg
  /** In seconds */
  updateInterval?: number
  direction?: 'fromNow' | 'toNow'
}

export const RelativeTime: TFC<TRelativeTimeProps> = ({
  updateInterval = 10,
  date,
  direction = 'fromNow',
  minDate,
  maxDate,
}) => {
  const getRelativeTime = useCallback(() => {
    let d = date

    if (minDate && dayjs(minDate).isAfter(d)) {
      d = minDate
    }
    if (maxDate && dayjs(maxDate).isBefore(d)) {
      d = maxDate
    }
    return dayjs(d)[direction]()
  }, [date, direction, maxDate, minDate])
  const [relativeTime, setRelativeTime] = useState(getRelativeTime)
  useEffect(() => setRelativeTime(getRelativeTime), [getRelativeTime])
  useInterval(() => setRelativeTime(getRelativeTime), updateInterval * 1000)
  return <>{relativeTime}</>
}
